import React, { useState, useContext, useCallback } from 'react';
import { Context } from '../../../context/AppContext';
import { MODALS } from '../../../constants';
import useScrollPosition from '../../../hooks/useScrollPosition';
import './styles.css';

const MobileCTA = ({ quotable }) => {
  const [show, setShow] = useState();
  const {
    modal: { showModal },
  } = useContext(Context);

  const callback = useCallback(({ top }) => {
    if (top <= -100) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  useScrollPosition(null, callback);

  const animation = `ListviewMobileCTA${show ? 'Up' : 'Down'}`;
  const animationDuration = 500;

  if (quotable)
    return (
      <div
        className="Listview__MobileCTA__root"
        style={{
          animation: `${animation} ${animationDuration}ms cubic-bezier(0.1, 0.07, 0.44, 1) forwards`,
        }}
      >
        <div className="Listview__MobileCTA__content">
          {quotable && (
            <button
              className="Listview__MobileCTA__button--quotes"
              type="button"
              onClick={() => showModal(MODALS.QUOTE_FORM)}
            >
              Get Quotes
            </button>
          )}
        </div>
      </div>
    );
  return '';
};

export default MobileCTA;
